const SECOND = 1_000 as const;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

export { DAY, HOUR, MINUTE, SECOND };
